export default "__VITE_ASSET__DVj$VlJT__"